import { store } from 'ion-lib';

const generatedStore = store('ion-hausrat');

export default generatedStore;
